export interface QuickLink {
  id: string;
  nameKey: string;
  url: string;
  image: string;
  icon: string;
}

export const quickLinks: QuickLink[] = [
  {
    id: 'spreadsheet',
    nameKey: 'quick.spreadsheet',
    url: '/cssbuy-spreadsheet/',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20laptop%20screen%20displaying%20an%20organized%20colorful%20spreadsheet%20with%20product%20data%20rows%20and%20columns%2C%20clean%20modern%20desk%2C%20soft%20daylight%2C%20workspace%20productivity%20photography%2C%20crisp%20and%20professional&width=400&height=400&seq=quick-spreadsheet&orientation=squarish',
    icon: 'ri-table-2',
  },
  {
    id: 'products',
    nameKey: 'quick.products',
    url: '/cssbuy-spreadsheet/',
    image: 'https://readdy.ai/api/search-image?query=Curated%20selection%20of%20trendy%20fashion%20products%20including%20shoes%2C%20a%20handbag%20and%20sunglasses%20arranged%20on%20a%20minimal%20white%20display%2C%20soft%20studio%20lighting%2C%20ecommerce%20product%20photography%2C%20fresh%20modern%20retail%20aesthetic&width=400&height=400&seq=quick-products&orientation=squarish',
    icon: 'ri-shirt-line',
  },
  {
    id: 'qc',
    nameKey: 'quick.qc',
    url: '/cssbuy-warehouse/',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20a%20folded%20garment%20on%20a%20clean%20white%20inspection%20table%2C%20quality%20control%20concept%2C%20bright%20professional%20lighting%2C%20detailed%20product%20verification%20photography%2C%20clean%20clinical%20modern%20mood&width=400&height=400&seq=quick-qc&orientation=squarish',
    icon: 'ri-zoom-in-line',
  },
  {
    id: 'shipping',
    nameKey: 'quick.shipping',
    url: '/cssbuy-shipping-cost/',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20parcels%20with%20packing%20tape%20and%20a%20clipboard%20on%20a%20light%20background%2C%20international%20shipping%20concept%2C%20clean%20logistics%20photography%2C%20soft%20natural%20light%2C%20organized%20minimal%20composition&width=400&height=400&seq=quick-shipping&orientation=squarish',
    icon: 'ri-truck-line',
  },
  {
    id: 'guides',
    nameKey: 'quick.guides',
    url: '/cssbuy-spreadsheet/',
    image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20and%20colorful%20guidebook%20tabs%20next%20to%20a%20tablet%20on%20a%20cozy%20desk%2C%20learning%20and%20guide%20concept%2C%20warm%20soft%20lighting%2C%20editorial%20flat%20lay%20photography%2C%20inviting%20and%20organized&width=400&height=400&seq=quick-guides&orientation=squarish',
    icon: 'ri-book-open-line',
  },
  {
    id: 'reviews',
    nameKey: 'quick.reviews',
    url: '/cssbuy-review/',
    image: 'https://readdy.ai/api/search-image?query=Five%20golden%20stars%20rating%20illustration%20with%20a%20tablet%20showing%20customer%20review%20cards%2C%20review%20concept%2C%20clean%20modern%20UI%20mockup%2C%20soft%20studio%20lighting%2C%20trustworthy%20feedback%20photography%2C%20bright%20and%20positive%20mood&width=400&height=400&seq=quick-reviews&orientation=squarish',
    icon: 'ri-star-line',
  },
  {
    id: 'coupons',
    nameKey: 'quick.coupons',
    url: '/cssbuy-coupon/',
    image: 'https://readdy.ai/api/search-image?query=Scissors%20cutting%20a%20discount%20coupon%20from%20a%20paper%20sheet%20with%20a%20percentage%20tag%2C%20saving%20and%20deals%20concept%2C%20bright%20clean%20studio%20photography%2C%20soft%20shadows%2C%20promotional%20ecommerce%20marketing%20shot%2C%20cheerful%20and%20clear&width=400&height=400&seq=quick-coupons&orientation=squarish',
    icon: 'ri-coupon-2-line',
  },
];